import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  kpis: [],
  kpis: null,
  sortAd: [],
  currentPage: null
}

const mutations = {  
  SET_CONTRACTORS (state, payload) {
    state.contractors = payload
  },
  SET_CONTRACTOR (state, payload) {
    state.contractor = payload
  },
  SET_SORT_AD (state, payload) {
    state.sortAd = payload
  },
  SET_CURRENT_PAGE (state, payload) {
    state.currentPage = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  contractorList: (context, data) => {
    let query = '?'        
    if (data.pagination) {
      query += `page=${data.pagination.page}&records=${data.pagination.perPage}`      
    } else {          
      query = ''
    }
    if (data.sort) {
      query += `&sortBy=${data.sort.sortBy}&sortDesc=${data.sort.sortDesc}`      
    }
    if (data.search) {
      query += `&search=${data.search}`      
    }

    return Vue.http.post(`${env.API}/api/contractor/list`, data)    
      .then((response) => {        
        context.commit('SET_CONTRACTORS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  contractorSelectList: (context, data) => {
    return Vue.http.get(`${env.API}/api/contractor/select-list`)    
      .then((response) => {        
        context.commit('SET_CONTRACTORS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  contractorByIds: (context, data) => {
    let query = '?'
    if (Array.isArray(data.ids)) {
      for (let element of data.ids) {                 
        query += `&ids[]=${element._id}`
      }
    }
    if (Array.isArray(data.role)) {
      for (let r of data.role) {
        query += `&role[]=${r._id}`
      }
    }
    return Vue.http.get(`${env.API}/api/contractor/by-ids${query}`)    
      .then((response) => {        
        context.commit('SET_CONTRACTORS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getContractorById: (context, id) => {
    return Vue.http.get(`${env.API}/api/contractor/by-id/${id}`)    
      .then((response) => {
        context.commit('SET_CONTRACTOR', response.body.message)            
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateContractor: (context, data) => {
    return Vue.http.put(`${env.API}/api/contractor/${data.id}`, data)    
      .then((response) => {                
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  createContractor: (context, data) => {
    return Vue.http.post(`${env.API}/api/contractor`, data)
    .then((response) => {
      return response.body.message
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })
  },
  deleteContractor: (context, data) => {
    return Vue.http.delete(`${env.API}/api/contractor/${data.id}`, data)
    .then((response) => {
      return response.body.message
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })
  },
  updateSortAd: (context, data) => {
    return context.commit('SET_SORT_AD', data)
  },
  updateCurrentPage: (context, page) => {
    return context.commit('SET_CURRENT_PAGE', page)
  }
}

const getters = {
  getContractors: (state) => state.kpis,
  getContractor: (state) => state.kpi,
  getSortAd: (state) => state.sortAd,
  getCurrentPage: (state) => state.currentPage
}

export const contractor = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/contractor.js